export default {
    color: "text-blue-900",
    link: "text-white  hover:text-blue-800",

    topBar: "bg-white",
    sideBar: "",
    textPrimary: "text-blue-600 hover:text-blue-800",
    logoBar: "text-blue-900",

    pButton: "bg-blue-800 text-white hover:bg-gray-500 ",
    sButton: "bg-gray-500 text-white hover:bg-blue-800  ",
    primary: "text-white bg-gray-500 hover:bg-blue-700",

    filter: "bg-white text-blue-800 border-blue-800 hover:bg-blue-800",
    required: "text-blue-500",
    actionTable: "text-black opacity-75   hover:text-blue-500",
    newColor: "text-blue-500 hover:text-blue-500 ",
    pButton1: "bg-blue-500 text-white hover:bg-gray-500 ",
    primary1: "text-white bg-gray-500 hover:bg-blue-500",
    white: "text-white",
};
